import React, { FC } from 'react';
import styled from 'styled-components';
import { Skeleton } from './Skeleton';

export interface ChipsSelectSkeletonProps {
  /*! default value: [70, 130] */
  randomWidthAsNumber?: [number, number];
  /*! default value: 25 */
  amountOfChips?: number;
}

export const ChipsSelectSkeleton: FC<React.PropsWithChildren<ChipsSelectSkeletonProps>> = ({
  randomWidthAsNumber = [70, 130],
  amountOfChips = 25
}) => (
  <StyledChipsSkeletons>
    {[...Array(amountOfChips)]
      .map((_, index) => index)
      .map((index) => (
        <Skeleton key={index} height={32} randomWidthAsNumber={randomWidthAsNumber} />
      ))}
  </StyledChipsSkeletons>
);

const StyledChipsSkeletons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacingSize.m};
  flex-wrap: wrap;
  > * {
    // Simulate chips
    &.MuiSkeleton-text {
      border-radius: 16px;
      transform: none;
    }
  }
`;
